export const employmentMixin = {
  methods: {
    getEmploymentType(employmentCode) {
      switch (Number(employmentCode)) {
        case 1:
          return {
            name: 'Employment',
            code: employmentCode,
          };
        case 2:
          return {
            name: 'Self-employment',
            code: employmentCode,
          };
        case 3:
          return {
            name: 'Employment / Self-Employment',
            code: employmentCode,
          };
        default:
          return { name: '', code: employmentCode };
      }
    },
  },
};
